import React, { useContext, useEffect, useState } from 'react'
import { AuthContext } from '../../store/auth-context'
import styles from './Comments.module.css'
import { getCookie } from '../../utils/common';
import { conversationFeedbackAPI } from '../../services/api/conversation-feedback';
import Spinner from '../UI/Spinner';
import { useParams } from 'react-router-dom';
import DirectComments from './DirectComments';
import SectionalComments from './SectionalComments';
import { hasSpecialCharacters, replaceHtmlTags } from '../Common/Common';


const Comments = ({rightPanelActiveComponent, toggleRightPanelComponent, curTime, setPlaying, id, type}: any) => {

    // const {id} = useParams()
    const authCtx = useContext(AuthContext)
    const isAdmin = authCtx.userRole === 'admin'
    const isQA = authCtx.userRole === 'qa'
    const isManager = authCtx.userRole === 'manager'

    const [isLoading, setIsLoading] = useState(true)
    const [commentText, setCommentText] = useState('')
    const [sectionalComments, setSectionalComments] = useState<Array<{[key: string]: any}>>([])
    const [directComments, setDirectComments] = useState<Array<{[key: string]: any}>>([])
    const [commentsFilter, setCommentsFilter] = useState('')
    const [CommentHasSplChar, setCommentHasSplChar] = useState("");

    useEffect(() => {
        if(rightPanelActiveComponent === 'comments') {
            getConversationFeedback()
        }
    }, [rightPanelActiveComponent])
    
    // Get all direct and sectional comments 
    const getConversationFeedback = () => {
        const tenantSlug = getCookie('current_tenant')
        conversationFeedbackAPI(tenantSlug).getAll?.(`/?conversation_id=${id}`)
            .then((response) => {
                getSectionalDirectComments(response)
                setIsLoading(false)                
            })
            .catch((err: any) => {
                setIsLoading(false)
                if (err.response) {
                    console.log(err.response)
                } else if (err.request) {
                    console.log(err.request)
                } else {
                    console.log(err)
                }
            })
    }

    const getSectionalDirectComments = (response: any) => {
        let sectionalComments: Array<{[key: string]: any}> = []
        let directComments: Array<{[key: string]: any}> = []
        response.map((item: any) => {
            if(item.is_direct_comment) {
                directComments.push(item)
            } else {
                sectionalComments.push(item)
            }
        })
        setSectionalComments(sectionalComments)
        setDirectComments(directComments)
    }

    const onChangeHandler = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        setPlaying(false)
        setCommentText(e.target.value)
    }

    const addComment = () => {
        setCommentHasSplChar("");
        let cmtText = replaceHtmlTags(commentText)
        if(!cmtText.trim()) {
            return
        }
        if (hasSpecialCharacters(cmtText)) {
            setCommentHasSplChar("Special characters are not allowed in the Comment");
            return;
        }
        const tenantSlug = getCookie('current_tenant')
        const data = {
            "conversation_id": id,
            "is_direct_comment": true,
            "comment": cmtText,
            "time_stamp": Math.round(curTime || 0),
        }
        conversationFeedbackAPI(tenantSlug).post?.(data)
            .then((response) => {
                setCommentText('')
                getConversationFeedback()
            })
            .catch((err: any) => {
                if (err.response) {
                    console.log(err.response)
                } else if (err.request) {
                    console.log(err.request)
                } else {
                    console.log(err)
                }
            })
    }

    return (
        <div className={styles.commentsContainer} hidden={rightPanelActiveComponent === 'comments' ? false : true }>
            {
                isLoading ?
                <div className="d-flex justify-content-center my-5">
                    <Spinner size="md" />
                </div>
                :
                <>
                    <div>
                        <div  className="d-flex justify-content-between">
                        <h5 className={styles.containerTitle}>Feedback</h5>
                        <span onClick={() => toggleRightPanelComponent()}><i className="bi bi-x-square fs-5"></i></span>
                        </div>
                        <div>
                            {/* Filter */}
                        <select className="form-select form-select-sm w-50" defaultValue={commentsFilter} onChange={(e) => setCommentsFilter(e.target.value)}>
                            <option value=''>All Feedback</option>
                            <option value='current_user'>My Feedback</option>
                        </select>
                        </div>
                    </div>
                    <div className={styles.overflowScroll}>
                        <ul className="my-3 p-0">
                            { 
                                directComments.length > 0 ?
                                    <DirectComments 
                                        type={type}
                                        directComments={directComments}
                                        setCommentText={setCommentText}
                                        getConversationFeedback={getConversationFeedback}
                                        commentsFilter={commentsFilter}
                                        id={id}
                                    /> :
                                    null
                            }
                        </ul>
                        <ul className="my-3 p-0">
                            { 
                                sectionalComments.length > 0 ?
                                    <SectionalComments 
                                        sectionalComments={sectionalComments}
                                        commentsFilter={commentsFilter}
                                    /> :
                                    null
                            }
                        </ul>
                    </div>
                    {
                        (isAdmin || isQA || isManager) &&
                            <div className={`${styles.textareaContainer} d-flex`}>
                                <textarea
                                    className="d-flex p-3 w-100"
                                    placeholder="Add your comment here ..."
                                    value={commentText}
                                    onChange={onChangeHandler}
                                /> 
                                {
                                    CommentHasSplChar ? 
                                    (
                                        <span className={styles.error}>{CommentHasSplChar}</span>
                                    ) : 
                                    null
                                }
                                <button type="button" className={`btn link-primary float-end ${styles.addCommentBtn}`} onClick={addComment}>Add Comment</button>
                            </div>
                    }
                </>
            }
        </div>
    )
}

export default Comments
